/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RoleResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The RoleResource model module.
   * @module model/RoleResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RoleResource</code>.
   * A resouce for creating and updating a role.
   * @alias module:model/RoleResource
   * @class
   * @param name {String} Required. The name of role.
   */
  var exports = function(name) {
    var _this = this;


    _this['name'] = name;


  };

  /**
   * Constructs a <code>RoleResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RoleResource} obj Optional instance to populate.
   * @return {module:model/RoleResource} The populated <code>RoleResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('autoAssign')) {
        obj['autoAssign'] = ApiClient.convertToType(data['autoAssign'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * The ID of role.
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * Required. The name of role.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * The description of role.
   * @member {String} description
   */
  exports.prototype['description'] = undefined;
  /**
   * A value indicates if this role will be assigned to the new user account automatically. \"true\", it will be assigned to the new user account, otherwise not. Defaults to false.
   * @member {Boolean} autoAssign
   */
  exports.prototype['autoAssign'] = undefined;



  return exports;
}));



